// extracted by mini-css-extract-plugin
export default {"subtitle":"styles_subtitle__yFQa7","buttons":"styles_buttons__55TC0"};